//////////////////////////////////////
// override DPO cart page qty - trigger DPO configure and popup update buttons

document.addEventListener("DOMContentLoaded", (event) => {

document.addEventListener('on:line-item:change', (event) => {
  if(document.querySelector("html.is-cart") !== null && document.querySelector("#cart-items.dpo-update-cart") == null){
    //setTimeout(function(){
      //if(window.console){ console.log("line-item-change DPO"); }
      location.reload();
    //},300);
  }
});

var cartItemBox = document.querySelector('#cart-items');
var timeoutQTY = null;

// use check for comnfigure button (.dpo-cart-edit)
$q('html.jquery-is-loaded #cart-items .has-custom-options .dpo_cart_edit_container .dpo_cart_edit').wait(true,(elm) => {
//waitForElm('#cart-items .has-custom-options .dpo_cart_edit_container .dpo_cart_edit', true).then((elm) => {//'html.jquery-is-loaded .has-custom-options .qty-input__btn.btn.btn--minus'

  if(window.console){ console.log("line-item-change DPO loaded"); }

  //if(document.querySelector("#cart-items .has-custom-options") !== null){

    //console.log('jquery is function',typeof jQuery);
  
    jQuery("#cart-items .has-custom-options .qty-input__btn.btn.btn--minus").off("click");
    jQuery("#cart-items .has-custom-options .qty-input__btn.btn.btn--plus").off("click");
    jQuery("#cart-items .has-custom-options .qty-input__input.input").off("keydown");
    jQuery("#cart-items .has-custom-options .qty-input__input.input").off("input"); 
    jQuery("#cart-items .has-custom-options .qty-input__input.input").off("change");  
    jQuery("#cart-items .has-custom-options quantity-input").off("click");
    //jQuery("#cart-items").off("click");

    //alternate way to remove event listeners
    /*const button = document.querySelector('button);
    // replace the element with a copy of itself
    // and nuke all the event listeners
    button.replaceWith(button.cloneNode(true));*/
  
    for (var qtyInputCombined of document.querySelectorAll('.has-custom-options .qty-input.qty-input--combined')) {

      //console.log(qtyInputCombined);

      qtyInputCombined.parentElement.addEventListener('click', function(evt) {

        evt.preventDefault();
        evt.stopImmediatePropagation();
        evt.stopPropagation();
        //console.log('stop quantity-input');
        return false;
      });

      //console.log(qtyInputCombined);
  
      $q(qtyInputCombined.closest('tr.cart-item')).addClass("configure-exists");
  
      let qtyInput = qtyInputCombined.querySelector('.has-custom-options .qty-input__input');
      let currentQty = qtyInput.value;
    
      // qty plus - minus
      qtyInputCombined.addEventListener('click', function(evt) {
  
          //console.log(evt.target);
          //console.log("qty plus - minus");
    
          //if (!evt.target.closest('.qty-input__btn')) return;
          if (!evt.target.matches('.qty-input__btn')) return;
          evt.preventDefault();
          evt.stopImmediatePropagation();
          evt.stopPropagation();
  
          $q(cartItemBox).addClass('pointer-events-none');
          $q(cartItemBox).addClass('dpo-update-cart');
          let trCartItem = qtyInput.closest("tr.cart-item");
          let trCartItemID = trCartItem.id;        
          document.querySelector('#cart-items #' + trCartItemID + ' .cart-item__loader').removeAttribute("hidden");        
          let variantID = trCartItem.dataset.variantId;
          currentQty = qtyInput.value;
    
          if (evt.target.name === 'plus') {
            qtyInput.stepUp();
          } else {
            qtyInput.stepDown();
          }
    
          if (qtyInput.value !== currentQty) {          
            //qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
            currentQty = qtyInput.value;  
            fetchNewQty(variantID, trCartItemID, currentQty);
          } else {
            $q(cartItemBox).addClass('pointer-events-none', 'dpo-update-cart');
            document.querySelector('#cart-items #' + trCartItemID + ' .cart-item__loader').removeAttribute("hidden");
          }
      });
    
      // qty input - keydown 
      qtyInput.addEventListener('keydown', function(evt) {
    
          if (evt.key !== 'Enter') return;
          evt.preventDefault();
          evt.stopImmediatePropagation();
          evt.stopPropagation();
        
          $q(cartItemBox).addClass('pointer-events-none', 'dpo-update-cart');
          let trCartItem = qtyInput.closest("tr.cart-item");
          let trCartItemID = trCartItem.id;
          document.querySelector('#cart-items #' + trCartItemID + ' .cart-item__loader').removeAttribute("hidden");
          let variantID = trCartItem.dataset.variantId;
      
          if (qtyInput.value !== currentQty) {
            //qtyInput.blur();
            qtyInput.focus();
            currentQty = qtyInput.value;    
            fetchNewQty(variantID, trCartItemID, currentQty);
          } else {
            $q(cartItemBox).addClass('pointer-events-none', 'dpo-update-cart');
            document.querySelector('#cart-items #' + trCartItemID + ' .cart-item__loader').removeAttribute("hidden");
          }
      });
  
      // qty input - keydown 
      qtyInput.addEventListener('input', function(evt) {
        
          evt.preventDefault();
          evt.stopImmediatePropagation();
          evt.stopPropagation();
  
          clearTimeout(timeoutQTY);
          setTimeout(function(){
            
            $q(cartItemBox).addClass('pointer-events-none', 'dpo-update-cart');
            let trCartItem = qtyInput.closest("tr.cart-item");
            let trCartItemID = trCartItem.id;
            document.querySelector('#cart-items #' + trCartItemID + ' .cart-item__loader').removeAttribute("hidden");
            let variantID = trCartItem.dataset.variantId;
      
            if (qtyInput.value !== currentQty) {
              //qtyInput.blur();
              qtyInput.focus();
              currentQty = qtyInput.value;    
              fetchNewQty(variantID, trCartItemID, currentQty);
            }else {
              $q(cartItemBox).addClass('pointer-events-none', 'dpo-update-cart');
              document.querySelector('#cart-items #' + trCartItemID + ' .cart-item__loader').removeAttribute("hidden");
            }
          },280);
      });
    
      // qty input - focus
      qtyInput.addEventListener('focus', function(evt) {
          if (window.matchMedia('(pointer: fine)').matches) {
            evt.target.select();
          }
      });
    }

  //}
});

// update cart qty - qty plus - minus qty
function fetchNewQty(variantID, trCartItemID, quantity) {

  //console.log('fetchNewQty');
  
  $q(cartItemBox).addClass('pointer-events-none', 'dpo-update-cart');
  document.querySelector('#cart-items #' + trCartItemID + ' .cart-item__loader').removeAttribute("hidden");

  //console.log('variantID',variantID);
  //console.log('trCartItemID',trCartItemID);
  //console.log('quantity',quantity);

   // new way
   /* if(typeof window.dpoObserver !== "undefined"){

    let cartKey = "";
    let cartItems = window.dpoObserver.cartItems;
    for (var cartItem of cartItems) {
        //console.log(cartItem);
        if (variantID == cartItem.id) {
           cartKey = cartItem.key;
        }
    }
    
    //dpoObserver.cartQuantityChange: function(cart_item_key, qty, onSuccess, onError);
    dpoObserver.cartQuantityChange(
          cartKey, 
          quantity,
          function(){
            if(window.console){console.log("DPO fetch success");}
            setTimeout(function(){
              location.reload();
              setTimeout(function(){
                $q(cartItemBox).removeClass('pointer-events-none');
                document.querySelector('#cart-items #' + trCartItemID + ' .cart-item__loader').setAttribute("hidden", "");                  
              },2000);
            },1000);
         },
         function(){
            if(window.console){console.log('error updating quantity'); }
            $q(cartItemBox).removeClass('pointer-events-none');
            document.querySelector('#cart-items #' + trCartItemID + ' .cart-item__loader').setAttribute("hidden", "");
         }
    );
  } else {// end if window.dpoObserver
    if(window.console){console.log('DPO observer does not exist'); }
    $q(cartItemBox).removeClass('pointer-events-none');
    document.querySelector('#cart-items #' + trCartItemID + ' .cart-item__loader').setAttribute("hidden", "");
  } */

  // old way
  var formData = new FormData();
  formData.append("updates[" + variantID + "]", quantity);
  //console.log(formData);

  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    body: formData
  })
  .then(response => {
    return response.json();
  })
  .then(data => {
    //location.reload();
    //if(window.console) { 
      //console.log("fetch success");
      //console.log(data);
      //console.log(window.dpoObserver.cartItems);
      //console.log(data.items[0].key);
    //}
    //dpoObserver.cartQuantityChange: function(cart_item_key, qty, onSuccess, onError);
    dpoObserver.cartQuantityChange(
        data.items[0].key, 
        quantity,
        function(){
         //document.location = '/cart';
         setTimeout(function(){
           location.reload();
           setTimeout(function(){
              //Util.removeClass(document.querySelector('#cart-items'), "pointer-events-none");
              $q('#cart-items').removeClass("pointer-events-none");
              document.querySelector('#cart-items #' + trCartItemID + ' .cart-item__loader').setAttribute("hidden", "");
           },2000);
         },550);
       },
       function(){
         if(window.console) { console.log('error updating quantity...');}
         setTimeout(function(){
          $q('#cart-items').removeClass("pointer-events-none");
          document.querySelector('#cart-items #' + trCartItemID + ' .cart-item__loader').setAttribute("hidden", "");
        },1000);
       }
    );
    //document.querySelector('#cart-items #' + trCartItemID + ' .dpo_cart_edit_container .dpo_cart_edit').dispatchEvent(new Event('click'));
    //setTimeout(function(){
        //document.querySelector('#itoris_dynamicproductoptions_popup #itoris_dynamicoptions_add_to_cart').dispatchEvent(new Event('click'));
        //setTimeout(function(){
          ////Util.removeClass(document.querySelector('#cart-items'), "pointer-events-none");
          //$q('#cart-items').removeClass("pointer-events-none");
          //document.querySelector('#cart-items #' + trCartItemID + ' .cart-item__loader').setAttribute("hidden", "");
        //},2000);
    //},800);
  })
  .catch((error) => {
    if(window.console) { console.error('Error:', error); }
    //Util.removeClass(document.querySelector('#cart-items'), "pointer-events-none");
    $q('#cart-items').removeClass("pointer-events-none");
    document.querySelector('#cart-items #' + trCartItemID + ' .cart-item__loader').setAttribute("hidden","");
  });
}

}); // end dom ready